import React, { useEffect, useState } from "react";
import { fetchProjects } from "../../api/api";

const ProjectList = ({ workspace_id, refresh }) => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (!workspace_id) return;

    const loadProjects = async () => {
      try {
        const data = await fetchProjects(workspace_id);
        setProjects(data.projects || []);
      } catch (err) {
        console.error(err);
      }
    };

    loadProjects();
  }, [workspace_id, refresh]);

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title mb-3">Projects</h5>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {projects.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center text-muted">
                  No projects found
                </td>
              </tr>
            ) : (
              projects.map((p) => (
                <tr key={p.id}>
                  <td>{p.name}</td>
                  <td>{p.description}</td>
                  <td>{p.status || "active"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectList;
